"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = View;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledTextInput = require("./StyledTextInput");
var _excluded = ["prefix", "suffix", "viewValue", "viewModeWithPrefixSuffix"];
function View(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    viewValue = _ref.viewValue,
    viewModeWithPrefixSuffix = _ref.viewModeWithPrefixSuffix,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var value = typeof viewValue !== 'undefined' && viewValue !== '' ? viewValue : '-';
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledTextInput.ViewModeWrapper, (0, _extends2.default)({
      theme: theme
    }, restProps), prefix && viewModeWithPrefixSuffix && /*#__PURE__*/_react.default.createElement(_StyledTextInput.ViewModePrefix, null, prefix), /*#__PURE__*/_react.default.createElement(_StyledTextInput.ViewModeChildren, null, value), suffix && viewModeWithPrefixSuffix && /*#__PURE__*/_react.default.createElement(_StyledTextInput.ViewModeSuffix, null, suffix));
  });
}